
import {
    Box,
    Dialog,
    DialogContent,
    Step,
    Stepper,
    Typography,
    IconButton
} from "@mui/material";
import { useEffect, useState } from "react";
import { statusColors } from './utils';
import { BiListUl } from "react-icons/bi";
import { CustomConnector, CustomStepIconRoot, CustomStepLabel } from './styled';
import AdjustIcon from '@mui/icons-material/Adjust';
import LensIcon from '@mui/icons-material/Lens';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


const CustomStepIcon = (iconColor) => {

    return (
        <CustomStepIconRoot
            color={statusColors[iconColor]}
        >
            {iconColor == 'completed' && (
                <CheckCircleIcon style={{ color: statusColors[iconColor] }} />
            )}
            {iconColor == 'failed' && (
                <LensIcon style={{ color: statusColors[iconColor] }} />

            )}
            {iconColor == 'inprogress' && (
                <AdjustIcon style={{ color: statusColors[iconColor] }} />
            )}
            {iconColor == 'disabled' && <AdjustIcon style={{ color: statusColors[iconColor] }} />
            }
        </CustomStepIconRoot>
    );
};


export const AutomatedProvisioning = (props) => {

    const [steps, setSteps] = useState(
        [
            { label: 'Grant Consent to Enterprise Application', description: 'Pending....', status: 'disabled' },
            { label: 'Connect to Microsoft Teams', description: 'failed....', status: 'disabled' },
            { label: 'Create east/west child domains', description: 'inprogress...', status: 'disabled' },
        ]
    );

    const handleClose = () => {
        props.setOpen(false);
    };

    const checkCompletedSteps = (stepData, step) => {
        const status = stepData?.details.toLowerCase();

        setSteps((prevSteps) =>
            prevSteps.map((item, index) => {
                if (index === step - 1) {  // step index
                    if (status.includes('error')) {
                        return { ...item, status: 'failed', description: 'Failed while processing.' };
                    }
                    if (status.includes('completed')) {
                        return { ...item, status: 'completed', description: 'Completed successfully.' };
                    }
                    if (status.includes('inprogress')) {
                        return { ...item, status: 'inprogress', description: 'In progress...!' };
                    }
                    return item; // no match
                }
                return item;
            })
        );
    };



    const getProvisioningStatus = async () => {
        if (props.data.length == 0) return;
        if (props?.data) {
            const getLatestByStatus = (status) =>
                props.data
                    .filter(res => res.status == status)
                    .reduce((latest, current) =>
                        new Date(current.createdDateTime) > new Date(latest.createdDateTime)
                            ? current
                            : latest
                    );

            const step1 = getLatestByStatus(1) //step 1
            checkCompletedSteps(step1, 1)

            const step2 = getLatestByStatus(2) //step 2
            checkCompletedSteps(step2, 2)

            const step3 = getLatestByStatus(3, 3) //step 3
            checkCompletedSteps(step3, 3)
        }

    }

    useEffect(() => {
        getProvisioningStatus()
    }, [props.open]);

    return (
        <Dialog
            onClose={handleClose}
            open={props.open}
            sx={{ padding: '0px !important' }}
        >
            <DialogContent sx={{ padding: '5px 10px' }}>
                <Box>

                    <IconButton aria-label="close" sx={{ boxShadow: 2, borderRadius: 2 }} >
                        <BiListUl />
                    </IconButton>
                    <Box>
                        <h3 variant="h6" style={{ margin: '0px' }}>Automated Provisioning Status</h3>
                        <Typography sx={{ p: 0, fontSize: '14px' }}>Follow the real-time status of your setup.</Typography>
                        <Box>
                            <Stepper orientation="vertical" connector={<CustomConnector />}>
                                {steps.map((step, index) => (
                                    <Step key={index} active={step.active}
                                        stepColor={statusColors[step.status]}
                                        completed={step.completed}
                                        error={step.error}
                                    >
                                        <CustomStepLabel StepIconComponent={() => CustomStepIcon(step.status)}
                                            stepColor={
                                                step.status == 'completed' ? '' : statusColors[step.status]
                                            }
                                        >
                                            {step.label}
                                            <div className="MuiStepLabel-description">{step.description}</div>
                                        </CustomStepLabel>
                                    </Step>
                                ))}
                            </Stepper>

                        </Box>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
}